module.exports = __webpack_public_path__ + "img/36.a8969b62.png";